import React from 'react';
import { connect } from 'react-redux';
import { MessageBarType } from '@fluentui/react';
import { Button, Switch } from '@fluentui/react-components';
import { useEffect, useState } from 'react';
import { useBoolean } from '@fluentui/react-hooks';

// i18next
import { useTranslation } from 'react-i18next';

// functions
import * as ComponentFunctions from './PractitionerSettingsForm.Functions';

// guide components
import { GuideDrawer, GuideDrawerSection } from '../../../../theme/components/GuideDrawer';

// components
import ContractsSelectorComponent from '../../../../commons/component/Inputs/ContractSelector/ContractSelectorComponent';
import ProtocolContractFormComponent from '../../../Contracts/Protocols/ProtocolContractForm/ProtocolContractFormComponent';
import { MessageComponent } from '../../../../commons/component/MessageComponent';
import PractitionerConceptsListComponent from '../PracititionerConceptsList/PractitionerConcepts.List.Component';

// models
import { Contract } from '../../../../models/Entities/Contracts/Contract';
import { ContractCommissionAgent } from '../../../../models/Entities/Contracts/ContractCommissionAgent';
import { NewContractCommissionAgent } from '../../../../models/Entities/Contracts/NewContractCommissionAgent';
import { CommissionAgentTypeEnum } from '../../../../models/Entities/Contracts/CommissionAgentType';

const PractitionerSettingsForm = (props: ComponentFunctions.Props) => {

    // useTranslation()
    const [t] = useTranslation();

    const [submittedForm, setSubmittedForm] = useState<boolean>(false);
    const [hasSeenLoadingState, setHasSeenLoadingState] = useState<boolean>(false);

    // useEffect(() => {
    //     props.GetAllContracts();
    // }, []);

    useEffect(() => {
        
        if (props.isOpen && !props.isLoadingAgents && props.AgentsLoaded && props.Agent?.id === undefined) {

            //alert('create agent');

            var NewAgent: NewContractCommissionAgent = {
                contractId: props.ContractId,
                commissionAgentId: props.Practitioner.practitionerUserId,
                commissionAgentName: props.GetPractiontioner(props.Practitioner.practitionerUserId)?.fullName,
                currency: 'USD',
                commissionAmount: 0,
                contractAssociatedId: undefined,
                haveContractAssociated: false,
                isCommissionAPercentage: true,
                onlyDoneHimSelf: false,
                // Este formulario es el del equipo del protocolo: lo que da de alta
                // es siempre un profesional.
                commissionAgentType: CommissionAgentTypeEnum.Practitioner
            } as NewContractCommissionAgent;

            props.CreateContractCommissionAgent(NewAgent);

        }

    }, [props.isOpen === true && props.Agent === undefined]);

    useEffect(() => {
        if (props.Agent) {
            setPayFixValue(!props.Agent.isCommissionAPercentage);
            setFixValue(props.Agent.commissionAmount);
            setCurrency(props.Agent.currency);
            setPercentage(props.Agent.commissionAmount);
            setHaveContractAssociated(props.Agent.haveContractAssociated);
            setContractId(props.Agent.contractAssociatedId);
            setOnlyMadeByHimSelf(props.Agent.onlyDoneHimSelf);
        }

    }, [props.Practitioner?.practitionerUserId, props.Agent?.id]);

    useEffect(() => {
        console.log('Estados cambiaron:');
        console.log('- submittedForm:', submittedForm);
        console.log('- isSaving:', props.isSaving);
        console.log('- isUpdating:', props.isUpdating);
        console.log('- isSavedSuccessfully:', props.isSavedSuccessfully);
        console.log('- isUpdatedSuccessfully:', props.isUpdatedSuccessfully);
        
        // Trackear cuando vemos el estado de loading
        if (submittedForm && (props.isSaving || props.isUpdating)) {
            console.log('Vimos el estado de loading!');
            setHasSeenLoadingState(true);
        }
    }, [submittedForm, props.isSaving, props.isUpdating, props.isSavedSuccessfully, props.isUpdatedSuccessfully]);

    useEffect(() => {
        // Solo auto-cerrar si vimos el loading state
        if (submittedForm && hasSeenLoadingState && (props.isSavedSuccessfully || props.isUpdatedSuccessfully)) {
            console.log('Auto-cerrando formulario (vimos loading)');
            setSubmittedForm(false);
            setHasSeenLoadingState(false);
            props.dismissPanel();
        }
    }, [submittedForm, hasSeenLoadingState, props.isSavedSuccessfully, props.isUpdatedSuccessfully]);

    const [isOpenContractPanel, { setTrue: openContractPanel, setFalse: dismissContractPanel }] =
        useBoolean(false);

    
    // internal marks
    const [payFixValue, setPayFixValue] = useState<boolean>(true);
    const [paySimple, setPaySimple] = useState<boolean>(false);
    const [payByConcept, setPayByConcept] = useState<boolean>(false);

    const [FixValue, setFixValue] = useState<number>(0);
    const [Currency, setCurrency] = useState<string>();
    const [Percentage, setPercentage] = useState<number>(0);
    const [haveContractAssociated, setHaveContractAssociated] = useState<boolean>(false);
    const [ContractId, setContractId] = useState<number>();
    const [onlyMadeByHimSelf, setOnlyMadeByHimSelf] = useState<boolean>(false);
    const [discountAlreadyPaidToSI, setDiscountAlreadyPaidToSI] = useState<boolean>(false);

    const ResetForm = () => {
        setPayFixValue(true);
        setFixValue(0);
        setCurrency(undefined);
        setPercentage(0);
        setHaveContractAssociated(false);
        setContractId(undefined);
        setOnlyMadeByHimSelf(false);

    };


    const HandleCancelForm = () => {
        //ResetForm();
        props.dismissPanel();
    };


    // events
    const HandleSaveForm = () => {
        console.log('HandleSaveForm ejecutado');
        console.log('props.isSaving:', props.isSaving);
        console.log('props.isUpdating:', props.isUpdating);

        setSubmittedForm(true);

        var currentCommissionAgent: NewContractCommissionAgent | ContractCommissionAgent | undefined;
        if (props.Agent?.id) {
            currentCommissionAgent = {
                id: props.Agent?.id,
                contractId: props.ContractId,
                commissionAgentId: props.Practitioner.practitionerUserId,
                commissionAgentName: props.GetPractiontioner(props.Practitioner.practitionerUserId)?.fullName,
                currency: Currency,
                commissionAmount: payFixValue ? FixValue : Percentage,
                contractAssociatedId: ContractId,
                haveContractAssociated: haveContractAssociated || false,
                isCommissionAPercentage: !payFixValue || false,
                onlyDoneHimSelf: onlyMadeByHimSelf || false,
                discountAlreadyPaidToSI: discountAlreadyPaidToSI || false,
                commissionAgentType: CommissionAgentTypeEnum.Practitioner
            } as ContractCommissionAgent;

            console.log('Llamando UpdateContractCommissionAgent con:', currentCommissionAgent);
            props.UpdateContractCommissionAgent(currentCommissionAgent as ContractCommissionAgent);
        }
        else {
            currentCommissionAgent = {
                contractId: props.ContractId,
                commissionAgentId: props.Practitioner.practitionerUserId,
                commissionAgentName: props.GetPractiontioner(props.Practitioner.practitionerUserId)?.fullName,
                currency: Currency,
                commissionAmount: FixValue | Percentage,
                contractAssociatedId: ContractId,
                haveContractAssociated: haveContractAssociated || false,
                isCommissionAPercentage: !payFixValue || false,
                onlyDoneHimSelf: onlyMadeByHimSelf || false,
                discountAlreadyPaidToSI: discountAlreadyPaidToSI || false,
                commissionAgentType: CommissionAgentTypeEnum.Practitioner
            } as NewContractCommissionAgent;

            props.CreateContractCommissionAgent(currentCommissionAgent as NewContractCommissionAgent);
        }
    }


    const isBusy = props.isSaving || props.isUpdating;

    const FormFields = (
        <>
            <GuideDrawerSection
                title={t('contractAssociation.formValidation.selectContract', 'Debe seleccionar un contrato')}
                description={t(
                    'practitionerSettingsForm.contractAssociationHint',
                    'Active la asociacion de contrato para vincular una liquidacion existente con este profesional.'
                )}
                testId="practitioner-settings-contract-section"
            >
                <Switch
                    label={'Contrato asociado'}
                    checked={haveContractAssociated}
                    onChange={(_event, data) => setHaveContractAssociated(!!data.checked)}
                />

                <ContractsSelectorComponent
                    onSelectedContract={
                        (contracts: Contract[]) => setContractId(contracts[0]?.id)
                    }
                    ContractsSelected={
                        props.Agent?.contractAssociatedId ? [props.Agent?.contractAssociatedId] : undefined
                    }
                    MultiselectEnable={false}
                    disabled={!haveContractAssociated}
                />

                <div>
                    <Button
                        appearance="secondary"
                        onClick={openContractPanel}
                        disabled={isBusy || !haveContractAssociated}
                    >
                        {'Agregar contrato'}
                    </Button>
                </div>
            </GuideDrawerSection>

            <GuideDrawerSection
                title={t('contractDetailPage.contractDetailItem.conceptsSettled', 'Conceptos a liquidar')}
                description={t(
                    'practitionerSettingsForm.conceptsHint',
                    'Defina los conceptos coparticipables para este profesional. Si hay contrato asociado, esta seccion queda en solo lectura.'
                )}
                testId="practitioner-settings-concepts-section"
            >
                {props.Practitioner && (
                    <PractitionerConceptsListComponent
                        PractitionerId={props.Practitioner.practitionerUserId}
                        CommissionAgentId={props.Agent?.id}
                        ContractId={props.ContractId}
                        ProtocolId={props.ProtocolId}
                        disabled={haveContractAssociated}
                    />
                )}
            </GuideDrawerSection>
        </>
    );

    const Forms = (
        <>
            <ProtocolContractFormComponent
                isOpen={isOpenContractPanel}
                Contract={undefined}
                dismissPanel={dismissContractPanel}
                openPanel={openContractPanel}
                mode=''
                RefererId={undefined}
            />
        </>
    )

    const ErrorMessage = props.error && (
        <>
            <MessageComponent
                message={'Ocurrio un error al grabar la informacion de la comisión'}
                subMessage={props.error.ErrorMessage}
                itemList={props.error.Errors}
                type={
                    MessageBarType.error
                }
            />
        </>
    );

    return (
        <GuideDrawer
            open={props.isOpen}
            size="medium"
            title={props.GetPractiontioner(props.Practitioner?.practitionerUserId)?.fullName || 'No Name'}
            subtitle={props.Practitioner?.studyRole?.name || 'No title'}
            onDismiss={props.dismissPanel}
            testId="practitioner-settings-drawer"
            secondaryAction={{ label: t('conceptForm.footer.cancelButton'), onClick: HandleCancelForm }}
            primaryAction={{
                label: isBusy ? t('common.saving') : t('conceptForm.footer.saveButton'),
                onClick: HandleSaveForm,
                loading: isBusy,
            }}
        >
            {ErrorMessage}
            {FormFields}
            {Forms}
        </GuideDrawer>
    );

};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(PractitionerSettingsForm as any);

